import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ReactDOM from 'react-dom';
import ModalVideo from 'react-modal-video';
import UserLoginType from '../../../views/login/UserLoginType';
import Whatsapp from '../../../views/login/Whatsapp.js';

import ProductConfig from '../../../config/ProductConfig.json';
import HmAjax from '../../../util/HmAjax';
import PreLoginPage from '../../../views/core/PreLoginPage';

// ES6 class-style
class Productbox extends PreLoginPage {

	constructor (props) {
		super(props);
		
	    this.state = {
		  error: null,
	      isLoaded: false,
	      items: [],
	      ProductList: [],
	      pro_detail: [],
	      products : [],
	      self: [],
	      plp:[],
	      products_details: {},
	      products_category_order:[]
	    }
		
		this.grades = this.props.grades;
	    this.productClass = this.props.products_class;
	    this.productDetails = this.props.products_details;
	    this.products_category = this.props.products_category;
	    this.productClasses = this.props.classes;
	    this.renderFooterProduct = this.renderFooterProduct.bind(this);
	    this.restricted = false;
	  }

	  componentDidMount() {

	  	const { products,self,plp } = this.state;
	  	this.grades = this.props.grades;
	  	this.productClass = this.props.products_class;
	  	this.productDetails = this.props.products_details;
	  	this.products_category = this.props.products_category;
	  	this.productClasses = this.props.classes;
		// console.log("this.state ",this.state,this.products_category)
	}

	loadsplbox(){
		var me=this;
			return(
				<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
				{me.loadsplcomp()}
				</div>
			)
	}

	loadplpbox(){
		var me=this;
			return(
				<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
				{me.loadplpcomp()}
				</div>
			)
	}

	loadlessoncompAll(){
			return(
				<div className="row prolesscomp">
					<div>
					{this.loadsplbox()}
					</div>
				<div>
				{this.loadplpcomp()}
					</div>
					</div>
			)
	}

	loadlessoncomp(){
		var me=this;
		if(me.props.device =="web"){
					return(
									<div className="row prolesscomp">
												 <div>
												 {this.loadsplbox()}
													 </div>
								 <div>
									{this.loadplpcomp()}
												</div>
													</div>
				 )
 }else{
				 return(
								 <div className="row prolesscomp">
														<div>
														{this.loadplpcomp()}
														</div>
									<div>
									{this.loadsplbox()}
													</div>                                      
													 </div>               
							)       
			}        
 }

	getProdDetails(){
		//console.log(this.state.products_details);
	   if(this.state.products_details !== {} && this.state.products_details !== undefined){
	   return this.state.products_details;
	 }
   }

	renderFooterProduct(product,grade){
		//console.log(product,", ",grade,", ",this.productClasses);
		if(product && grade && this.products_category && this.products_category[product] && this.products_category[product].hasOwnProperty(grade)){ 			
			var restricted = ""
			if(this.GradeRestrictionManager.isGradeRestricted(grade)){
				restricted = "restricted";
				this.restricted = true;
			}
			return (<span className={restricted} key={grade} data-ga={'Home - Top - '+ProductConfig[product].ganame+' - '+this.productClasses[grade].ClassName}  onClick={() => this.saveID(`${grade}`,`${this.products_category[product][grade]}`,ProductConfig[product].url+this.products_category[product][grade])}>
				{this.productClasses[grade].ClassName.substr(6)}
				{(() => {
					  if(restricted == "restricted"){
						  return "*";
					  }
			  })()}
			</span>);		   
		}  		
	}

	
	saveID(grade,proID,link){
		const {products_details} = this.state;
		var me =this;
		var callBackSuccess = function(result){
	  if(result !== null){
		  
		  me.setState({
			products_details: result
		  }),
		 //console.log("Footer:::",me.getProdDetails());
			 localStorage.setItem('grade',grade);
			localStorage.setItem('product',proID);
		  localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));

		  window.top.location.href=link;

	  }

	  //console.log("response : ", response);
	  }
  
	  var callBackFailure = function(response){
		  me.setState({
			  isLoaded: true,
			  error:"Error in Footer PRODUCT_JSON"
			});
		  console.log("Error in Footer PRODUCT_JSON in Grade");		
	  }
  
	  var formData = {
			  "levelId":grade
	  }
	  new HmAjax(this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);
	  
	  //console.log(grade);
		//console.log(proID);
		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"class-"+grade+"-btn-click-home"});
			this.tracked = true;
		}
	}

	loadsplcomp(){
		var me=this;
	//	if(this.checkRestrictedGrade(ProductConfig.SPL.productKey,this.grades) == false){
return(
<div className="splwell spl">
				<div className="row">
					<div className="col-2 text-center">
				<span className="proimg"><img src="../img/e1.png" alt="Self-Paced Lessons"/></span>
					</div>
				<div className="col-10 combox textAlignLeft">
				<div><h2>{this.rb("SPL")}</h2></div>
				<div><span>{this.rb("SPL.build")}</span>
				</div>
			</div>
			</div>

			<div className="row hrborder">
			<div className="col-2 text-center"></div>
				<div className={"col-10 "+"clsdata-"+this.props.device}>
				<strong className="clsspan splcls">{this.rb("home.classes")}</strong>
				 {me.orderProducts(me.state.products_category_order).map(product => {
					//if(me.checkRestrictedGrade(product,me.grades) == false){
						if(product=="SPL"){
						return(
							<div className="probox" key={product}>
								
								{me.grades.map(grade => (
									me.renderFooterProduct(product,grade)	
								))}
												
							</div> 
						);
								}
					//}
			})} 
			{me.checkRestrictedGrade(ProductConfig.SPL.productKey,this.grades)}
			<span className="ntxt">
			<span><i className="fa">&#xf156;</i> {this.rb("banner.SPL")}</span>
			</span>

				</div>
				
				</div>
				{/* <div className="ntxt text-left">
				<span><i className="fa">&#xf156;</i> {this.rb("banner.SPL")}</span>
				</div> */}
				</div>
)
	//	}
	}

	loadplpcomp(){
		var me=this;
		return(
			<div className="splwell plp">
			<div className="row">
				<div className="col-2 text-center">
				<span className="proimg"><img src="../img/e3.png" alt="Personalised Learning"/></span>
				</div>
				<div className="col-10 combox textAlignLeft">
				<div><h2>{this.rb("PLP")}</h2></div>
				<div><span>{this.rb("PLP.build")}</span>
				</div>
				</div>
				</div>
				
				<div className="row hrborder">
				<div className="col-2 text-center"></div>
						<div className={"col-10 "+"clsdata-"+this.props.device}>
						<strong className="clsspan plpcls">{this.rb("home.classes")}</strong>
						<div className="showrow">
						
						{me.orderProducts(me.state.products_category_order).map(product => {
							
							//if(me.checkRestrictedGrade(product,me.grades) == false){
								if(product=="PLP" || product=="EXAM_PREP_CBSE"){
								return(
									<div className="probox" key={product}>
											{me.grades.map(grade => (
												me.renderFooterProduct(product,grade)	
											))}				
									</div> 
								);
									}
							//}
					})}
						</div>
						{/* {console.log("Grades rest ",me.state.products_category_order)} */}
						{me.checkRestrictedGrade(ProductConfig.PLP.productKey,me.grades)}
						<span className="ntxt">
			<span><i className="fa">&#xf156;</i> {this.rb("banner.EXAM_PREP_CBSE")}</span>
			</span>

				</div>
				</div>
				{/* <div className="ntxt text-left">
				<span><i className="fa">&#xf156;</i> {this.rb("banner.EXAM_PREP_CBSE")}</span>
				</div> */}
				</div>
)
	}


	checkRestrictedGrade(product,grades){		
		//console.log("grades:::",grades, ", ",product);
		//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
	  var restrictedAvailable = false;
	  if(grades && grades.length > 0){			
		  for(var i=0;i<grades.length;i++){
			if(product && this.products_category && this.products_category[product] && this.products_category[product].hasOwnProperty(grades[i])){ 			
			 		if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){
						restrictedAvailable = true;
						break;
					}
			  }
		  }
	  }
	  if(restrictedAvailable){
		return (<div className="text-left smallinfo">
					*Available only for desktop
				</div>
				);	   
	}
	// else{ restrictedAvailable = true; }
	//   return restrictedAvailable;
	 }


 orderProducts(obj){
	if(obj && typeof obj === "object"){
		//console.log("Object.values(obj) "+Object.values(obj))
		return Object.values(obj);
	}else{
		return [];
	}
 }


  render() {
	const { products,self,plp } = this.state;
	this.grades = this.props.grades;
	this.grades_order = this.props.grades_order;
	this.productClass = this.props.products_class;
	this.productDetails = this.props.products_details;
	this.products_category = this.props.products_category;
	this.productClasses = this.props.classes;
	this.state.products_category_order = this.props.products_category_order;
	
    const tifOptions = [];
    
  	return(
          <div>
               {this.loadlessoncompAll()}
          </div>
  	);
  }
}

export default Productbox;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Productbox.js